import { StatisticalAnalysisSampleTagsDossierExternalInfo } from '@/modules/statistical-analysis-module/views/labeled-samples-dossier/labeled-samples-dossier.model'
import { Nullable } from '@/shared/types/app.types'

export interface StatisticAnalysisExternalViewSampleTagsStatisticsState {
    externalInfo: Nullable<StatisticalAnalysisSampleTagsDossierExternalInfo>
}
export const initialStatisticAnalysisExternalViewSampleTagsStatisticsState =
    (): StatisticAnalysisExternalViewSampleTagsStatisticsState => ({
        externalInfo: null
    })
